import Net from '@pngs/LearningMapPage/Net.png';
import { Flex, theme } from '@styles';
import { string } from 'prop-types';
import React from 'react';
import { ClipLoader } from 'react-spinners';

const FullscreenClipLoader = ({ backgroundSource, color, size, width }) => (
  <Flex
    alignItems="center"
    backgroundImage={backgroundSource}
    backgroundPosition="left"
    backgroundSize="contain"
    height="100vh"
    justifyContent="center"
    width={width}
  >
    <ClipLoader color={color} loading size={size} />
  </Flex>
);

FullscreenClipLoader.propTypes = {
  backgroundSource: string,
  color: string,
  size: string,
  width: string,
};

FullscreenClipLoader.defaultProps = {
  backgroundSource: Net,
  color: theme.colors.schoolBusYellow[100],
  size: '75px',
  width: 'auto',
};

export default FullscreenClipLoader;
